import React, { PropTypes } from 'react';

const Provider = ({ provider, providerSelect }) => {
    const { id, name, appLink } = provider;
    let clickHandler;
    let href = appLink;
    if (providerSelect) {
        clickHandler = (event) => { event.preventDefault(); return providerSelect(provider); };
        href = null;
    }
    return (
        <li key={id}>
            <a
                href={href}
                onClick={clickHandler}
            >
                {name}
            </a>
        </li>
    );
};

Provider.propTypes = {
    provider: PropTypes.object,
    providerSelect: PropTypes.func
};

export default Provider;



// WEBPACK FOOTER //
// ./app/common/chooseProvider/Provider.js